import AdminDashboard from '../components/AdminDashboard'
import React from 'react'

function AdminPage() {
  return (
    <div>
      <AdminDashboard/>
    </div>
  )
}

export default AdminPage
